"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _SalesCallout = _interopRequireDefault(require("../../components/SalesCallout/SalesCallout"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var SalesCalloutHomeTryon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SalesCalloutHomeTryon, _PureComponent);

  function SalesCalloutHomeTryon() {
    _classCallCheck(this, SalesCalloutHomeTryon);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesCalloutHomeTryon).apply(this, arguments));
  }

  _createClass(SalesCalloutHomeTryon, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_react.default.Fragment, null, this.props.theme.brand === 'menguin' ? _react.default.createElement(_SalesCallout.default, {
        ctaPageName: this.props.ctaPageName,
        calloutId: "sales_callout_home_try_on",
        headline: "Free Home Try\u2011on.",
        body: _react.default.createElement(_react.default.Fragment, null, "You won\u2019t find this in stores. Ensure the right fit with a free home\xA0try\u2011on."),
        ctaTitle: "Start Try-on",
        ctaUrl: "/home-try-on",
        image: "https://gentux.imgix.net/1560437572_menguin-sales-callout-hto.jpg",
        imageAlt: "Menguin shipping box"
      }) : _react.default.createElement(_SalesCallout.default, {
        ctaPageName: this.props.ctaPageName,
        calloutId: "sales_callout_home_try_on",
        headline: "Free Home Try\u2011on.",
        body: _react.default.createElement(_react.default.Fragment, null, "You won\u2019t find this in stores. Ensure the right fit with a free home\xA0try\u2011on."),
        ctaTitle: "Start Try-on",
        ctaUrl: "/home-try-on",
        image: "https://gentux.imgix.net/1538947718_20181007-172019-box-tie.png",
        imageMobile: "https://gentux.imgix.net/1538947718_20181007-172019-box-tie.png?fm=jpg&q=60&fit=crop&crop=focalpoint&fp-y=1&w=245&h=140",
        imageAlt: "Generation Tux shipping box"
      }));
    }
  }]);

  return SalesCalloutHomeTryon;
}(_react.PureComponent);

var _default = (0, _styledComponents.withTheme)(SalesCalloutHomeTryon);

exports.default = _default;